import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import PageNavigation from "@/components/PageNavigation";
import SEOHead from "@/components/seo/SEOHead";

export default function PoliticaCookies() {
  return (
    <>
      <SEOHead
        title="Política de Cookies"
        description="Política de Cookies do Vendas Trainer. Saiba como utilizamos cookies e tecnologias similares para melhorar sua experiência."
        keywords="cookies, política de cookies, rastreamento, privacidade"
        canonicalUrl="https://bianchimbusiness.com.br/politica-cookies"
      />

      <Header />

      <main id="main-content" className="min-h-screen bg-background pt-20" role="main" aria-labelledby="page-title">
        <article className="container mx-auto px-4 py-16 max-w-4xl">
          <header>
            <h1 id="page-title" className="text-4xl font-bold text-foreground mb-8">Política de Cookies</h1>
          </header>
          
          <div className="prose prose-lg dark:prose-invert max-w-none space-y-6 text-muted-foreground">
            <p className="text-lg"><strong>Última atualização:</strong> Janeiro de 2026</p>

            <section className="space-y-4" aria-labelledby="what-section">
              <h2 id="what-section" className="text-2xl font-semibold text-foreground">O que são Cookies?</h2>
              <p>Cookies são pequenos arquivos de texto armazenados no seu dispositivo quando você visita nosso site. Eles nos ajudam a melhorar sua experiência, lembrar suas preferências e entender como você usa nossa plataforma.</p>
            </section>

            <section className="space-y-4" aria-labelledby="types-section">
              <h2 id="types-section" className="text-2xl font-semibold text-foreground">Tipos de Cookies que Usamos</h2>
              
              <h3 className="text-xl font-medium text-foreground">Cookies Essenciais</h3>
              <p>Necessários para o funcionamento básico do site. Incluem cookies de sessão e autenticação.</p>
              <ul className="list-disc pl-6 space-y-1" role="list">
                <li>Manter você logado</li>
                <li>Garantir a segurança da navegação</li>
                <li>Lembrar itens no carrinho</li>
              </ul>

              <h3 className="text-xl font-medium text-foreground">Cookies de Desempenho</h3>
              <p>Coletam informações sobre como você usa o site para nos ajudar a melhorá-lo.</p>
              <ul className="list-disc pl-6 space-y-1" role="list">
                <li>Páginas mais visitadas</li>
                <li>Erros encontrados</li>
                <li>Tempo de carregamento</li>
              </ul>

              <h3 className="text-xl font-medium text-foreground">Cookies de Funcionalidade</h3>
              <p>Lembram suas preferências para personalizar sua experiência.</p>
              <ul className="list-disc pl-6 space-y-1" role="list">
                <li>Idioma preferido</li>
                <li>Configurações de exibição</li>
                <li>Preferências de notificação</li>
              </ul>

              <h3 className="text-xl font-medium text-foreground">Cookies de Marketing</h3>
              <p>Usados para exibir anúncios relevantes e medir a eficácia de campanhas.</p>
              <ul className="list-disc pl-6 space-y-1" role="list">
                <li>Rastreamento de conversões</li>
                <li>Remarketing</li>
                <li>Análise de campanhas</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="third-section">
              <h2 id="third-section" className="text-2xl font-semibold text-foreground">Cookies de Terceiros</h2>
              <p>Utilizamos serviços de terceiros que podem instalar cookies:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Google Analytics:</strong> Análise de tráfego e comportamento</li>
                <li><strong>Google Tag Manager:</strong> Gerenciamento de tags e scripts</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="manage-section">
              <h2 id="manage-section" className="text-2xl font-semibold text-foreground">Como Gerenciar Cookies</h2>
              <p>Você pode controlar e gerenciar cookies de várias formas:</p>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Configurações do navegador:</strong> A maioria dos navegadores permite bloquear ou excluir cookies</li>
                <li><strong>Ferramentas de terceiros:</strong> Extensões como Privacy Badger ou Ghostery</li>
              </ul>
              <p><strong>Nota:</strong> Bloquear cookies essenciais pode afetar o funcionamento do site.</p>
            </section>

            <section className="space-y-4" aria-labelledby="storage-section">
              <h2 id="storage-section" className="text-2xl font-semibold text-foreground">Tempo de Armazenamento</h2>
              <ul className="list-disc pl-6 space-y-2" role="list">
                <li><strong>Cookies de sessão:</strong> Expiram quando você fecha o navegador</li>
                <li><strong>Cookies persistentes:</strong> Permanecem por até 2 anos</li>
                <li><strong>Cookies de terceiros:</strong> Variam conforme o provedor</li>
              </ul>
            </section>

            <section className="space-y-4" aria-labelledby="contact-section">
              <h2 id="contact-section" className="text-2xl font-semibold text-foreground">Contato</h2>
              <p>Dúvidas sobre nossa política de cookies:</p>
              <address className="not-italic space-y-2">
                <p><strong>E-mail:</strong> <a href="mailto:junior@bianchimbusiness.com.br" className="text-primary hover:underline">junior@bianchimbusiness.com.br</a></p>
                <p><strong>Telefone:</strong> <a href="tel:+5516981960018" className="text-primary hover:underline">+55 (16) 98196-0018</a></p>
                <p><strong>Endereço:</strong> Rua Danilo Micalli, 50 - Santa Felícia, São Carlos – SP – CEP: 13563-264</p>
              </address>
            </section>
          </div>
        </article>
      </main>

      <PageNavigation />
      <Footer />
    </>
  );
}
